import React from 'react';

import './styles.scss';

import cx from "classnames";
import {StringUtils} from "../../../global/utils/string";

interface Props {
    status:string,
}

function StatusAsTag(props:Props) {
    const {status} = props;
    return (
        <div className={cx('status-as-tag', status)}>
            <div className='dot'/>
            <div className='text'>{StringUtils.camelCaseToRegular(status, false, true)}</div>
        </div>
    )
}

export default StatusAsTag;